import { ReactNode } from 'react';
import { Icon, PopoverContent, PopoverLauncher, Popover as SwanPopover } from '@vp/swan';

interface PopoverProps {
    content: ReactNode;
}

export const Popover = ({ content }: PopoverProps) => (
    <SwanPopover>
        <PopoverLauncher>
            <Icon iconType="info" size="standard" skin="standard" />
        </PopoverLauncher>
        <PopoverContent>{content}</PopoverContent>
    </SwanPopover>
);
